exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel[data-v-086b0889] {\n  font-weight: 600;\n  color: black;\n}\nth[data-v-086b0889] {\n  font-size: 13px;\n  font-family: Roboto;\n}\ntd[data-v-086b0889] {\n  font-size: 12px;\n  font-family: Roboto;\n}\n.mx-datepicker[data-v-086b0889] {\n  width: 251px !important;\n}\n.selected2[data-v-086b0889] {\n  font-weight: bold !important;\n}\n.position[data-v-086b0889] {\n  position: absolute;\n  right: 21px;\n  top: 190px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-086b0889","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/components/reports/putawayPending/putawayPending.component.scss
// module id = 1450
// module chunks = 0